<aside
  *ngIf="open()"
  class="voice-drawer"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="labels.panelTitle"
>
  <header class="voice-drawer-header">
    <div class="voice-drawer-title-row">
      <img src="assets/logo/spark-icon-transparent.png" alt="Spark" class="voice-avatar" />
      <span class="voice-drawer-title">{{ labels.callTitle }}</span>
    </div>
    <button
      type="button"
      class="voice-icon-btn"
      [attr.aria-label]="labels.closeAria"
      (click)="close()"
    >
      &times;
    </button>
  </header>

  <div class="voice-drawer-body">
    <div class="voice-hero">
      <div class="voice-hero-ring" [class.active]="inCall()">
        <img src="assets/logo/spark-icon-transparent.png" alt="Spark" class="voice-hero-avatar" />
      </div>
      <h2 class="voice-hero-name">{{ labels.ai }}</h2>
      <p class="voice-status">{{ statusText() }}</p>
      <p class="voice-blurb" *ngIf="!inCall()">{{ labels.callBlurb }}</p>

      <ng-container *ngIf="isActive()">
        <p class="voice-duration">{{ callDuration() }}</p>
        <p class="voice-duration-label">{{ labels.callDuration }}</p>
      </ng-container>
    </div>

    <div class="voice-transcript" *ngIf="transcriptLines().length">
      <p class="voice-transcript-heading">{{ labels.liveTranscript }}</p>
      <div class="voice-transcript-list">
        <div
          class="voice-transcript-line"
          *ngFor="let line of transcriptLines()"
          [class.user]="line.role === 'user'"
          [class.assistant]="line.role === 'assistant'"
        >
          <span class="voice-transcript-role">{{ line.role === 'user' ? labels.user : labels.ai }}</span>
          <span class="voice-transcript-text">{{ line.text }}</span>
        </div>
      </div>
    </div>

    <div class="voice-controls">
      <ng-container *ngIf="inCall(); else idleCall">
        <button type="button" class="voice-ctrl" (click)="toggleMute()" [attr.aria-label]="isMuted() ? labels.unmuteAria : labels.muteAria">
          <span class="voice-ctrl-circle" [class.off]="isMuted()">
            <i class="fas" [class.fa-microphone]="!isMuted()" [class.fa-microphone-slash]="isMuted()"></i>
          </span>
          <span class="voice-ctrl-label">{{ isMuted() ? labels.unmute : labels.mute }}</span>
        </button>

        <button type="button" class="voice-ctrl hangup" [attr.aria-label]="labels.tapToEndCall" (click)="endCall()">
          <span class="voice-ctrl-circle hangup-circle">
            <i class="fas fa-phone"></i>
          </span>
          <span class="voice-ctrl-label">{{ labels.endCall }}</span>
        </button>

        <button type="button" class="voice-ctrl" (click)="toggleSpeaker()" [attr.aria-label]="labels.speakerAria">
          <span class="voice-ctrl-circle" [class.off]="!isSpeakerOn()">
            <i class="fas" [class.fa-volume-up]="isSpeakerOn()" [class.fa-volume-mute]="!isSpeakerOn()"></i>
          </span>
          <span class="voice-ctrl-label">{{ labels.speaker }}</span>
        </button>
      </ng-container>

      <ng-template #idleCall>
        <button
          type="button"
          class="voice-start"
          [disabled]="!canStart() || isStarting()"
          (click)="startCall()"
        >
          <i class="fas fa-phone"></i>
        </button>
        <p class="voice-start-label">{{ labels.tapToCall }}</p>
      </ng-template>
    </div>
  </div>
</aside>

<div class="voice-drawer-backdrop" *ngIf="open()" (click)="close()"></div>
